import React, { Component } from "react";

// Import Swiper styles

import { Bookmark, MapPin, ChevronRight, ChevronLeft } from "react-feather";
import { connect } from "react-redux";
// import Swiper core and required modules
import { Link } from "react-router-dom";

// install Swiper modules

class KnowUsMore extends Component {
  constructor(props) {
    super(props);

    this.state = {
      arr: [],
      ptag: "",
      currentPortfolio: [],
      currentPageNo: 1,
    };
  }

  paginate(array, page_size, page_number) {
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    return array.slice((page_number - 1) * page_size, page_number * page_size);
  }
  componentDidMount() {
    this.setState({
      currentPortfolio: this.paginate(
        this.props.knowusmore && this.props.knowusmore.Data,
        4,
        this.state.currentPageNo
      ),
    });
  }

  previousPage() {
    if (this.state.currentPageNo > 1) {
      this.state.currentPageNo = this.state.currentPageNo - 1;
      this.setState({
        currentPortfolio: this.paginate(
          this.props.knowusmore && this.props.knowusmore.Data,
          4,
          this.state.currentPageNo
        ),
      });
    }
  }
  nextPage() {
    if (this.state.currentPageNo >= 1) {
      this.state.currentPageNo = this.state.currentPageNo + 1;
      this.setState({
        currentPortfolio: this.paginate(
          this.props.knowusmore && this.props.knowusmore.Data,
          4,
          this.state.currentPageNo
        ),
      });
    }
  }
  render() {
    function getParameterByName(name, url = window.location.href) {
      name = name.replace(/[\[\]]/g, "\\$&");

      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";

      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    return (
      <>
        <div className=" container mx-auto  py-12">
          <div className="flex justify-between items-center  mb-8">
            <h2 className="fsize28 font-bold sm-fsize18">KNOW US MORE</h2>
            <div className="flex ">
              <ChevronLeft
                width="30px"
                height="30px"
                className="trend-left-i mr-2 cursor-pointer"
                onClick={() => this.previousPage()}
              />
              <ChevronRight
                width="30px"
                height="30px"
                className="trend-right-i cursor-pointer"
                onClick={() => this.nextPage()}
              />
            </div>
          </div>

          <div>
            <div className="lg:flex md:flex explore-list">
              {this.state.currentPortfolio.length > 0 ? (
                <div className="grid-1 lg:w-2/5 md:w-2/5 relative	w-full">
                  <div className="wrapper ">
                    <div className="">
                      {/* <img src = { this.props.knowmore ?`${process.env.REACT_APP_IMAGE_BASE_MG + '/' +  this.props.knowusmore.Data[0].p_path}`:""}/> */}
                      <h3 className="heading-20 pb-1">
                        {this.state.currentPortfolio
                          ? this.state.currentPortfolio[0].p_title
                          : ""}
                      </h3>
                      <p className="line-clamp-2">
                        {this.state.currentPortfolio[0].p_short_description}
                      </p>

                      {this.props.knowusmore && this.props.knowusmore.Data ? (
                        <Link
                          to={{
                            pathname:
                              process.env.PUBLIC_URL +
                              "/Career/know-us-more/" +
                              this.state.currentPortfolio[0].p_id,
                            state: this.state.currentPortfolio[0].p_value,
                          }}
                          class="btn btn-orange"
                        >
                          {this.state.currentPortfolio[0].p_button_Text !== null
                            ? this.state.currentPortfolio[0].p_button_Text
                            : "Read More"}
                        </Link>
                      ) : (
                        ""
                      )}
                    </div>
                    {this.state.currentPortfolio ? (
                      <div className="flex justify-end items-end know-gride-1 lg:mt-0 md:mt-0 mt-8 faded faded-top faded-left">
                        <img
                          src={
                            process.env.REACT_APP_IMAGE_BASE_MG +
                            "/" +
                            this.state.currentPortfolio[0].p_path
                          }
                          className="w-full h-250px rounded-md  "
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
              {this.state.currentPortfolio.length > 1 ? (
                <div className="flex flex-wrap lg:w-3/5 md:w-3/5 w-full	">
                  {this.state.currentPortfolio.length >= 1 ? (
                    <div className="grid-2 ">
                      <div className="wrapper lg:flex md:flex lg:justify-between md:justify-between">
                        <div className="set-width pr-4">
                          <h3 className="heading-20 pb-1">
                            {" "}
                            {this.state.currentPortfolio
                              ? this.state.currentPortfolio[1].p_title
                              : ""}
                          </h3>
                          <p className="line-clamp-2">
                            {this.state.currentPortfolio[0].p_short_description}
                            {/* {this.props.knowusmore.Data[1].p_desciption} */}
                          </p>
                          {this.props.knowusmore &&
                          this.props.knowusmore.Data ? (
                            <Link
                              to={{
                                pathname:
                                  process.env.PUBLIC_URL +
                                  "/Career/know-us-more/" +
                                  this.state.currentPortfolio[1].p_id,
                                state: this.state.currentPortfolio[1].p_value,
                              }}
                              className="btn btn-orange"
                            >
                              {this.state.currentPortfolio[1].p_button_Text !==
                              null
                                ? this.state.currentPortfolio[1].p_button_Text
                                : "Read More"}
                            </Link>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="lg:mt-0 md:mt-0 mt-8">
                          {this.props.knowusmore ? (
                            <img
                              src={
                                process.env.REACT_APP_IMAGE_BASE_MG +
                                "/" +
                                this.state.currentPortfolio[1].p_path
                              }
                              className="w-full h-160px rounded-md"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.currentPortfolio.length >= 2 ? (
                    <div className="grid-3 ">
                      <div className="wrapper flex">
                        <div className="">
                          <h3 className="heading-20 pb-1">
                            {this.state.currentPortfolio
                              ? this.props.knowusmore.Data[2].p_title
                              : ""}
                          </h3>
                          <p className="line-clamp-2">
                            {this.state.currentPortfolio[2].p_short_description}
                          </p>{" "}
                          <div className="flex justify-between">
                            {this.props.knowusmore &&
                            this.state.currentPortfolio ? (
                              <Link
                                to={{
                                  pathname:
                                    process.env.PUBLIC_URL +
                                    "/Career/know-us-more/" +
                                    this.state.currentPortfolio[2].p_id,
                                  state: this.state.currentPortfolio[2].p_value,
                                }}
                                className="btn btn-orange w-2/5	"
                              >
                                {this.state.currentPortfolio[2]
                                  .p_button_Text !== null
                                  ? this.state.currentPortfolio[2].p_button_Text
                                  : "Read More"}
                              </Link>
                            ) : (
                              ""
                            )}{" "}
                            {this.state.currentPortfolio ? (
                              <div className=" flex w-3/5 mt-6 justify-end">
                                <img
                                  src={
                                    process.env.REACT_APP_IMAGE_BASE_MG +
                                    "/" +
                                    this.state.currentPortfolio[2].p_path
                                  }
                                  className=" rounded-md h-120px"
                                />
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.currentPortfolio.length >= 3 ? (
                    <div className="grid-4">
                      <div className="wrapper flex">
                        <div className="">
                          <h3 className="heading-20 pb-1">
                            {this.state.currentPortfolio
                              ? this.state.currentPortfolio[3].p_title
                              : ""}
                          </h3>
                          <p className="line-clamp-2">
                            {this.state.currentPortfolio[0].p_short_description}
                          </p>
                          <div className="flex justify-between">
                            {this.state.currentPortfolio &&
                            this.state.currentPortfolio ? (
                              <Link
                                to={{
                                  pathname:
                                    process.env.PUBLIC_URL +
                                    "/Career/know-us-more/" +
                                    this.state.currentPortfolio[3].p_id,
                                  state: this.state.currentPortfolio[3].p_value,
                                }}
                                className="btn btn-orange w-2/5	"
                              >
                                {this.state.currentPortfolio[3]
                                  .p_button_Text !== null
                                  ? this.state.currentPortfolio[3].p_button_Text
                                  : "Read More"}
                              </Link>
                            ) : (
                              ""
                            )}
                            {this.state.currentPortfolio ? (
                              <div className=" flex w-3/5 mt-6 justify-end">
                                <img
                                  src={
                                    process.env.REACT_APP_IMAGE_BASE_MG +
                                    "/" +
                                    this.state.currentPortfolio[3].p_path
                                  }
                                  className="rounded-md h-120px"
                                />{" "}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    knowusmore: state.Home.home.KNOWUSMORE,
  };
};

export default connect(mapStateToProps)(KnowUsMore);
